export const CHART_COLORS      = [ '#b9bebd', '#0d8a8a', '#024e57', '#63c6c6', '#a5dcdc' ];
export const DONUT_COLORS      = [ '#0d8a8a', '#3d5a99', '#bf9b30', '#a34a35', '#63c6c6' ];
export const DONUT_OTHER_COLOR = '#b9bebd';

export function donutColor ( label : string, options : Array<string>, fallbackIndex : number ) : string {
  const optionIndex = options ? options.indexOf(label) : -1;
  const index = optionIndex >= 0
    ? optionIndex
    : fallbackIndex;

  return DONUT_COLORS[ index % DONUT_COLORS.length ];
}
